import { Cargo, CmdrShip, CreateProject, fc_loading, FindMarketsOptions, FoundMarkets, GlobalStats, Project, ProjectFC, SupplyStatsSummary } from "../types";
import { callAPI } from "./api-util";

/** Project APIs */
export const project = {

  create: async (project: CreateProject): Promise<Project> => {
    return await callAPI<Project>(
      `/api/project/`,
      'PUT',
      JSON.stringify(project)
    );
  },

  createFCLoading: async (buildName: string): Promise<Project> => {
    const newProject = {
      buildName: buildName,
      buildType: fc_loading,
      marketId: 1,
      systemAddress: 1,
      prepBuilds: {},
    } as CreateProject;

    return await callAPI<Project>(
      `/api/project/`,
      'PUT',
      JSON.stringify(newProject)
    );
  },


  createFrom: async (id64: number, systemSiteId: string, buildType?: string): Promise<Project> => {
    return await callAPI<Project>(`/api/project/from/${encodeURIComponent(id64.toString())}/${encodeURIComponent(systemSiteId)}/${encodeURIComponent(buildType ?? '')}`, 'POST');
  },

  get: async (buildId: string): Promise<Project> => {
    return await callAPI<Project>(`/api/project/${encodeURIComponent(buildId)}`);
  },

  getStats: async (buildId: string): Promise<SupplyStatsSummary> => {
    return await callAPI<SupplyStatsSummary>(`/api/project/${encodeURIComponent(buildId)}/stats`);
  },

  getManyStats: async (buildIds: string[]): Promise<SupplyStatsSummary[]> => {
    return await callAPI<SupplyStatsSummary[]>(`/api/project/stats`, 'POST', JSON.stringify(buildIds));
  },

  update: async (buildId: string, deltaProj: Partial<Project>): Promise<Project> => {
    return await callAPI<Project>(
      `/api/project/${encodeURIComponent(buildId)}`,
      'PATCH',
      JSON.stringify(deltaProj)
    );
  },

  delete: async (buildId: string): Promise<void> => {
    // TODO: pass back what we get?
    return await callAPI<void>(`/api/project/${encodeURIComponent(buildId)}`, 'DELETE');
  },

  setDefaultCargo: async (buildId: string): Promise<Project> => {
    return await callAPI<Project>(`/api/project/${encodeURIComponent(buildId)}/cargo/default`, 'POST');
  },

  last: async (buildId: string): Promise<string> => {
    return await callAPI<string>(`/api/project/${encodeURIComponent(buildId)}/last`);
  },

  poll: async (ids: string[]): Promise<Record<string, string>> => {
    return await callAPI<Record<string, string>>(`/api/project/poll`, 'POST', JSON.stringify(ids));
  },

  complete: async (buildId: string): Promise<void> => {
    return await callAPI<void>(`/api/project/${encodeURIComponent(buildId)}/complete`, 'POST');
  },

  linkCmdr: async (buildId: string, cmdr: string): Promise<void> => {
    // TODO: pass back what we get?
    return await callAPI<void>(`/api/project/${encodeURIComponent(buildId)}/link/${encodeURIComponent(cmdr)}`, 'PUT');
  },

  unlinkCmdr: async (buildId: string, cmdr: string): Promise<void> => {
    // TODO: pass back what we get?
    return await callAPI<void>(`/api/project/${encodeURIComponent(buildId)}/link/${encodeURIComponent(cmdr)}`, 'DELETE');
  },

  assignCmdr: async (buildId: string, cmdr: string, commodity: string): Promise<void> => {
    // TODO: pass back what we get?
    return await callAPI<void>(`/api/project/${encodeURIComponent(buildId)}/assign/${encodeURIComponent(cmdr)}/${encodeURIComponent(commodity)}/`, 'PUT');
  },

  unAssignCmdr: async (buildId: string, cmdr: string, commodity: string): Promise<void> => {
    // TODO: pass back what we get?
    return await callAPI<void>(`/api/project/${encodeURIComponent(buildId)}/assign/${encodeURIComponent(cmdr)}/${encodeURIComponent(commodity)}/`, 'DELETE');
  },

  setReady: async (buildId: string, commodities: string[], ready: boolean): Promise<void> => {
    // TODO: pass back what we get?
    return await callAPI<void>(
      `/api/project/${encodeURIComponent(buildId)}/ready`,
      ready ? 'DELETE' : 'POST',
      JSON.stringify(commodities)
    );
  },

  deliverToSite: async (buildId: string, cmdr: string, cargo: Cargo): Promise<Cargo> => {
    return await callAPI<Cargo>(
      `/api/project/${encodeURIComponent(buildId)}/supply/${encodeURIComponent(cmdr)}`,
      'POST',
      JSON.stringify(cargo)
    );
  },

  getCargoFC: async (buildId: string): Promise<Record<string, Cargo>> => {
    return await callAPI<Record<string, Cargo>>(`/api/project/${encodeURIComponent(buildId)}/fc/`);
  },

  /** Add a link between FC and a project */
  linkFC: async (buildId: string, marketId: string): Promise<ProjectFC[]> => {
    return await callAPI<ProjectFC[]>(`/api/project/${encodeURIComponent(buildId)}/fc/${encodeURIComponent(marketId)}`, 'PUT');
  },

  /** Remove a link between FC and a project */
  unlinkFC: async (buildId: string, marketId: number): Promise<ProjectFC[]> => {
    return await callAPI<ProjectFC[]>(`/api/project/${encodeURIComponent(buildId)}/fc/${encodeURIComponent(marketId)}`, 'DELETE');
  },

  globalStats: async (): Promise<GlobalStats> => {
    return await callAPI<GlobalStats>(`/api/stats/`);
  },

  findMarkets: async (options: FindMarketsOptions): Promise<FoundMarkets> => {
    return await callAPI<FoundMarkets>(`/api/project/markets`, 'POST', JSON.stringify(options));
  },

  getShips: async (buildIds: string[]): Promise<CmdrShip[]> => {
    return await callAPI<CmdrShip[]>(`/api/project/ships/`, 'POST', JSON.stringify(buildIds));
  },
};
